import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMatchNotFound = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 135,
	viewBox: "0 0 152 135",
	width: 152,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m76 134.991c37.106 0 67.186-30.217 67.186-67.4911 0-37.274-30.08-67.49062266-67.186-67.49062266-37.1059 0-67.18628 30.21662266-67.18628 67.49062266 0 37.2741 30.08038 67.4911 67.18628 67.4911z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m74.0002 117c30.3758 0 54.9998-24.6243 54.9998-55s-24.624-55-54.9998-55c-30.3756 0-55 24.6243-55 55s24.6244 55 55 55z",
			fill: "#4e678c",
			opacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m42.3353 81.1501-32.1306-.0979.1322-43.8466 22.2175.0676 9.883 9.9882z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m32.5544 37.2734-.03 9.958 9.913.0302z",
			fill: "#367cff",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m42.6396 47.2491c-.0012-.018-.0047-.0358-.0104-.0529-.0023-.0066-.0039-.0129-.0068-.0195-.0095-.0224-.0231-.0428-.0399-.0602l-9.883-9.9882c-.0173-.0172-.0377-.0311-.0599-.0411-.0062-.0027-.0126-.005-.0191-.007-.0171-.006-.035-.0096-.0532-.0107-.0043 0-.0081-.0027-.0124-.0027l-22.2174-.0668c-.0543 0-.1064.0217-.1447.0602-.0384.0386-.06.0909-.06.1454l-.1328 43.846c0 .0546.0216.1069.0599.1454.0384.0386.0905.0602.1447.0602l32.1295.0985c.0542 0 .1063-.0217.1447-.0602.0384-.0386.0599-.0909.0599-.1454l.1023-33.8887c.0011-.0039-.0012-.0078-.0014-.0123zm-9.883-9.4788 4.5636 4.6104 4.6238 4.6731-9.2144-.0282zm-22.3473 43.077.131-43.4355 21.8081.0664-.0293 9.7523c0 .0546.0216.1069.0599.1454.0384.0386.0905.0602.1447.0602l9.7085.0296-.1009 33.4776z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m97.838 89.1326-43.8153-.1334.1803-59.7922 30.2972.0923 13.4772 13.6205z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m84.5002 29.2993-.0409 13.5793 13.5181.0412z",
			fill: "#367cff",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m98.1796 42.9074c-.0011-.0179-.0046-.0356-.0102-.0526-.0023-.0068-.0041-.0132-.007-.0206-.0095-.0223-.023-.0427-.0397-.0602l-13.4772-13.6204c-.0174-.0172-.0377-.0311-.0599-.0412-.0064-.0028-.0125-.0045-.0191-.0067-.0171-.006-.035-.0097-.0532-.0109-.0043 0-.0082-.0025-.0125-.0025l-30.2972-.0923c-.0543 0-.1063.0217-.1447.0602-.0384.0386-.0599.0909-.0599.1454l-.1803 59.7921c0 .0545.0215.1068.0599.1454.0384.0385.0904.0602.1447.0602l43.8147.1334c.0543 0 .1064-.0216.1447-.0602.0384-.0386.06-.0908.06-.1454l.1394-46.2128c0-.0024-.0023-.0064-.0025-.0109zm-13.4766-13.1112 12.7806 12.9165-12.8195-.039zm-30.475 58.998.179-59.381 29.888.0911-.041 13.3737c0 .0546.0216.1068.06.1454.0384.0385.0904.0602.1447.0602l13.3134.0411-.1381 45.8017z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m141.693 81.1511-32.13-.0979.132-43.8467 22.217.0677 9.883 9.9882z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m131.912 37.2739-.03 9.958 9.913.0302z",
			fill: "#367cff",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m141.998 47.2499c-.001-.018-.005-.0358-.011-.0529-.002-.0065-.004-.0129-.007-.0195-.009-.0223-.023-.0427-.039-.0602l-9.883-9.9882c-.018-.0172-.038-.0311-.06-.0411-.007-.0029-.013-.0047-.019-.007-.018-.006-.035-.0096-.053-.0107-.005 0-.009-.0027-.013-.0027l-22.218-.0676c-.054 0-.106.0217-.144.0602-.039.0386-.06.0909-.06.1454l-.132 43.8466c0 .0546.021.1068.06.1454.038.0385.09.0602.144.0602l32.131.0979c.054 0 .106-.0217.145-.0602.038-.0386.06-.0909.06-.1454l.102-33.8887c-.001-.0031-.003-.007-.003-.0115zm-9.883-9.4788 4.562 4.6104 4.625 4.6731-9.214-.0282zm-22.347 43.077.131-43.4355 21.808.0664-.029 9.7524c0 .0545.022.1068.06.1453.038.0386.09.0602.145.0602l9.708.0296-.101 33.4776z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m65.0561 63.5876c1.694 0 3.0673-1.3795 3.0673-3.0812 0-1.7016-1.3733-3.0811-3.0673-3.0811s-3.0672 1.3795-3.0672 3.0811c0 1.7017 1.3732 3.0812 3.0672 3.0812z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m86.088 63.5876c1.694 0 3.0672-1.3795 3.0672-3.0812 0-1.7016-1.3732-3.0811-3.0672-3.0811s-3.0672 1.3795-3.0672 3.0811c0 1.7017 1.3732 3.0812 3.0672 3.0812z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m79.6842 69.0273h-8.2243c-.0543 0-.1063-.0216-.1447-.0602-.0384-.0385-.06-.0908-.06-.1453s.0216-.1068.06-.1454c.0384-.0385.0904-.0602.1447-.0602h8.2243c.0543 0 .1063.0217.1447.0602.0384.0386.06.0909.06.1454s-.0216.1068-.06.1453c-.0384.0386-.0904.0602-.1447.0602z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m61.8921 69.32c1.5111 0 2.7361-.6477 2.7361-1.4466 0-.799-1.225-1.4466-2.7361-1.4466s-2.7361.6476-2.7361 1.4466c0 .7989 1.225 1.4466 2.7361 1.4466z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m89.252 69.32c1.5112 0 2.7362-.6477 2.7362-1.4466 0-.799-1.225-1.4466-2.7362-1.4466-1.5111 0-2.7361.6476-2.7361 1.4466 0 .7989 1.225 1.4466 2.7361 1.4466z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#367cff",
			opacity: .4,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "m61.8921 69.32c1.5111 0 2.7361-.6477 2.7361-1.4466 0-.799-1.225-1.4466-2.7361-1.4466s-2.7361.6476-2.7361 1.4466c0 .7989 1.225 1.4466 2.7361 1.4466z",
				opacity: .4
			}), /* @__PURE__ */ _jsx("path", {
				d: "m89.252 69.32c1.5112 0 2.7362-.6477 2.7362-1.4466 0-.799-1.225-1.4466-2.7362-1.4466-1.5111 0-2.7361.6476-2.7361 1.4466 0 .7989 1.225 1.4466 2.7361 1.4466z",
				opacity: .4
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m98.0433 42.946c-5.2227-6.0235-12.6134-9.7162-20.5463-10.2661-7.933-.5499-15.7585 2.0882-21.7553 7.334-10.0186 8.765-13.0973 23.3372-7.4853 35.4408 1.1268 2.4252 2.5717 4.6881 4.2961 6.7284l.3684.4385-27.4619 29.2754c-.5022.544-.7702 1.264-.7455 2.005.0246.741.3399 1.442.877 1.951.5372.508 1.2526.782 1.9903.763.7378-.02 1.4379-.331 1.9478-.867l27.4551-29.2715.4586.3449c5.9248 4.4642 13.2847 6.5678 20.6616 5.9053 7.3768-.6626 14.2485-4.0442 19.291-9.4934 5.0421-5.4491 7.8991-12.5802 8.0191-20.019.119-7.4389-2.506-14.6591-7.3699-20.2693zm1.7217 21.4675c-.4252 6.1852-3.1685 11.9785-7.6771 16.2125-4.5085 4.234-10.4472 6.5938-16.6191 6.6039-.5699 0-1.1417-.0206-1.7154-.0617-4.0062-.2732-7.8835-1.5352-11.2879-3.6742-3.4044-2.1391-6.2308-5.0889-8.2284-8.588-1.9977-3.4991-3.1049-7.4393-3.2235-11.4713-.1186-4.0319.7551-8.0309 2.5436-11.6424s4.4366-6.7238 7.7093-9.061c3.2728-2.3372 7.0691-3.827 11.0523-4.3373 3.9832-.5104 8.0303-.0254 11.7822 1.4118 3.752 1.4372 7.0929 3.7822 9.7266 6.8271 2.1099 2.4228 3.7209 5.2416 4.74 8.2934 1.0191 3.0519 1.4261 6.2764 1.1974 9.4872z",
			fill: "#005ce6"
		})
	]
});
export { SvgMatchNotFound as ReactComponent };
